<template>
  <div>
    <!-- <v-app-bar color="#003D29" elevation="3" dark height="40px"> -->
      <v-layout wrap justify-center fill-height py-2 style="background-color: #003D29;">
        <v-flex xs12 sm12 md11 align-self-center text-left>
          <v-layout wrap justify-center>
            <v-flex xs6 sm3 md3 lg2 align-self-center text-center>
              <v-icon small style="color: white">mdi-phone</v-icon>
              &nbsp;<span class="topText">+91 8372938509</span>
            </v-flex>
            <v-flex xs6 sm3 md3 lg2 align-self-center text-left>
              <v-icon small style="color: white">mdi-email</v-icon>
              &nbsp;<span class="topText">admin@ntfp-ims</span>
            </v-flex>
            
            <v-spacer></v-spacer>
            <v-flex xs6 sm4 md4 lg4 text-center align-self-center pr-7 class="hidden-xs-only">
              <v-layout wrap justify-end>
                <v-flex xs2 sm1 v-for="(item, i) in items" :key="i">
                  <v-img :src="item.icon" height="18px" width="18px"></v-img>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    <!-- </v-app-bar> -->
  </div>
</template>
    <script>
//   import Notification from "./notification";
//import AccountMenuEco from "./accountMenuEco";
export default {
  components: {
    //   Notification,
    // AccountMenuEco,
  },
  data() {
    return {
      items: [
        { icon: require("./../../assets/icons/kIn.png") },
        { icon: require("./../../assets/icons/kX.png") },
        { icon: require("./../../assets/icons/kFb.png") },
      ],
    };
  },
};
</script>
    <style >
.v-toolbar__content {
  padding: 0px !important;
}
.topText {
  color: white;
  font-family: OutfitRegular;
  font-size: 14px;
}
</style>